import imageCompression from 'browser-image-compression';

export const compressImages = async (attachments: File[]) => {
  return Promise.all(attachments.map(compressImage));
};

export const compressImage = async (originalFile: File) => {
  const options = {
    maxSizeMB: 2,
    maxWidthOrHeight: 1400,
    useWebWorker: true,
  };

  try {
    const compressedBlob = await imageCompression(originalFile, options);
    return compressedBlob;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Image compression failed:', {
        fileName: originalFile.name,
        fileSize: originalFile.size,
        fileType: originalFile.type,
        errorMessage: error instanceof Error ? error.message : 'Unknown error',
      });
    }

    return originalFile; // If compression fails, return the original file
  }
};
